export default () => {
    if (typeof lenis === 'undefined') return
    
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            console.log(this.getAttribute('href'))
            window.lenis.scrollTo(this.getAttribute('href'))
        });
    })
}
